import { render, staticRenderFns } from "./Confirmer.vue?vue&type=template&id=0b5627f0&scoped=true&lang=pug"
import script from "./Confirmer.vue?vue&type=script&lang=ts"
export * from "./Confirmer.vue?vue&type=script&lang=ts"
import style0 from "./Confirmer.vue?vue&type=style&index=0&id=0b5627f0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b5627f0",
  null
  
)

export default component.exports